@import '~style-sheet-helpers/core.less';
@import (reference) '../../../products/product-details/style.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.active,
.active:hover {
  background-color: @grid-header--group-by--background-color;
}

.active-groupby-label {
  padding: 1px 5px;
  margin-left: 5px;
  background: @grid-header--active-group-by-label--background-color;
  border: @grid-header--active-group-by-label--border-color solid 1px;
  border-radius: 3px;
}

.dropdown-icon {
  height: 13px;
  width: 8px;
  margin-left: 5px;
}

.icon-button {
  border: none;
  background-color: transparent;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    background-color: @grid-header--icon-button--hover--background-color;
  }

  .icon {
    width: 8px;
    height: auto;
    color: @grid-header--active-group-by-button--text-color;
  }
}

.popover-title {
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
  background-color: @grid-header--active-group-by-popover--background-color;
  border-bottom: 1px solid @grid-header--active-group-by-popover--border-color;
  border-radius: 5px 5px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popover-body {
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;

  & > p {
    font-size: 14px;
  }

  .group-by-dd-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;

    .dropdown-menu {
      height: 35px;
      width: 265px;
    }
  }

  .combine-field-button {
    text-align: left;
    width: 200px;
    cursor: pointer;

    .icon {
      height: 8px;
      width: auto;
      margin-right: 5px;
    }
  }
}
